import { useMediaDevice } from "hooks/useMediaDevice";
import { DesktopHeader } from "./components/DesktopHeader";
import { MobileHeader } from "./components/MobileHeader";
import { useHeaderContext } from "providers/HeaderProvider";

export const Header = () => {
  const { isMobile } = useMediaDevice();
  const { setOpenLogin, setOpenRegister } = useHeaderContext();

  return (
    <>
      {isMobile ? (
        <MobileHeader {...{ setOpenLogin, setOpenRegister }} />
      ) : (
        <DesktopHeader {...{ setOpenLogin, setOpenRegister }} />
      )}
    </>
  );
};
